import React from "react";
import { Link } from "react-router-dom";

const PrivacyPolicy = () => {
  return (
    /* REMOVED: style={{ color: "#7A2E3A" }} */
    <div className="container legal-page">
      <Link to="/" className="back-link">
        <span>←</span> Back to home
      </Link>

      <h1>Privacy Policy</h1>

      <p className="effective-date">
        <strong>Effective Date: May 2, 2026</strong>
      </p>

      <h2>1. Data We Collect</h2>
      <p>
        To provide the leveling, RPG, and community features of Kami, we collect the
        following:
      </p>
      <ul>
        <li>
          <strong>User IDs:</strong> To track your level and essence.
        </li>
        <li>
          <strong>Server IDs:</strong> To store custom settings like welcome
          channels and roles.
        </li>
        <li>
          <strong>Message Content:</strong> Only when a command is explicitly
          triggered (e.g., custom AI interactions).
        </li>
      </ul>

      <h2>2. How We Use Data</h2>
      <ul>
        <li>
          We use your data solely to maintain your progress and to
          ensure the bot functions correctly within your server.
        </li>
        <li>
          <strong>We do not sell your data</strong> to third parties.
        </li>
      </ul>

      <h2>3. Data Retention & Deletion</h2>
      <ul>
        <li>
          <strong>Retention:</strong> Data is stored as long as the bot is
          present in your server.
        </li>
        <li>
          <strong>Deletion:</strong> If you wish to have your data purged from
          our records, please contact us at{" "}
          <strong>guardian@kamigrove.com</strong>.
        </li>
      </ul>
    </div>
  );
};

export default PrivacyPolicy;
